/**
 * Used to delay a function until the pending animation frame has drawn
 *
 * An example of usage is when an element's display: none is removed, it cannot be transitioned
 * that frame. The change to opacity for example must be done after the element has rendered
 * with a display other than none. If a transitioned property is changed while display is none,
 * the browser will skip the transition and set the property to the final value. This is
 * most likely an optimization that concluded the transition was pointless since the element wasn't
 * visible anyway.
 */
export function callAfterNextAnimationFrame(cb, n) {
  // requestAnimationFrame undefined, call the callback in 30ms
  if (!window.requestAnimationFrame) {
    return window.setTimeout(function () {
      return cb();
    }, 30);
  }

  if (n === 2) {
    return cb();
  }

  return window.requestAnimationFrame(function () {
    return callAfterNextAnimationFrame(cb, n ? n + 1 : 1);
  });
}